import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '@kts/client';
import { useT } from '@kts/i18n';
import { PageLoader } from '@kts/ui';
import type { Portal } from '@kts/shared';
import { api } from '@/lib/api';
import { applyServerLocale } from '@/lib/locale';
import { portalHome } from './nav';

/** Ilova ochilganda sessiyani tiklaydi (refresh cookie → access token → /me). */
export function AuthBoot({ children }: { children: ReactNode }) {
  const status = useAuth((s) => s.status);
  const savedLocale = useAuth((s) => s.me?.user.locale);
  const t = useT('app');
  useEffect(() => {
    if (status === 'loading') void useAuth.getState().init(api);
  }, [status]);
  // Serverda saqlangan til ustun: boshqa qurilmada tanlangan bo'lsa, shu yerda ham qo'llanadi.
  useEffect(() => {
    void applyServerLocale(savedLocale);
  }, [savedLocale]);
  if (status === 'loading') return <PageLoader label={t('boot.loading')} />;
  return <>{children}</>;
}

/** Portal himoyasi: kirish talab qilinadi va faol tashkilot turi portalga mos bo'lishi kerak. */
export function RequirePortal({ portal, children }: { portal: Portal; children: ReactNode }) {
  const { status, me } = useAuth();
  const loc = useLocation();
  if (status !== 'authed' || !me) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (me.portal !== portal) return <Navigate to={portalHome(me.portal)} replace />;
  return <>{children}</>;
}

/** `/` → foydalanuvchi portaliga. */
export function HomeRedirect() {
  const { status, me } = useAuth();
  if (status !== 'authed' || !me) return <Navigate to="/login" replace />;
  return <Navigate to={portalHome(me.portal)} replace />;
}
